import { styled } from 'baseui';
import { Card } from 'baseui/card';
import { FlexGrid, FlexGridItem } from 'baseui/flex-grid';
import React, { PropsWithChildren } from 'react';
import { Label2, Label3, LabelWithSublabel } from '../../labels';

export const DetailsContainer = styled('div', {
  marginTop: 0,
  marginBottom: 0,
  marginLeft: 0,
  marginRight: 0,
  paddingTop: '20px',
  paddingBottom: '20px'
});

export const flexGridItemOverrides = {
  Block: {
    style: {
      display: 'flex',
      height: '40px',
      alignItems: 'stretch',
      justifyContent: 'center'
    }
  }
};

export const cardOverrides = {
  Root: {
    style: {
      backgroundColor: 'white',
      marginTop: '0px',
      marginBottom: '10px',
      marginLeft: '0px',
      marginRight: '0px',
      borderTopLeftRadius: '3px',
      borderTopRightRadius: '3px',
      borderBottomRightRadius: '3px',
      borderBottomLeftRadius: '3px',
      paddingBottom: '48px'
    }
  },
  Body: {
    style: {
      marginTop: '0px',
      marginBottom: '0px',
      marginLeft: '0px',
      marginRight: '0px'
    }
  },
  Contents: {
    style: {
      marginTop: '0px',
      marginBottom: '0px',
      marginLeft: '0px',
      marginRight: '0px',
      paddingTop: '24px',
      paddingLeft: '24px',
      paddingRight: '24px',
      paddingBottom: '0px'
    }
  }
};

export const CardTitle = ({ title, subtitle }: { title: string; subtitle?: string }) =>
  subtitle ? <LabelWithSublabel title={title} subtitle={subtitle} /> : <Label3>{title}</Label3>;

export const BaseCard = ({
  title,
  subtitle,
  children
}: PropsWithChildren<{
  title: string;
  subtitle?: string;
}>) => (
  <Card
    overrides={{
      Title: {
        component: CardTitle,
        props: { title, subtitle }
      },
      ...cardOverrides
    }}
    title
  >
    <DetailsContainer>
      <FlexGrid flexGridColumnCount={3} flexGridColumnGap="scale700" flexGridRowGap="scale1200">
        {React.Children.map(
          React.Children.toArray(children).filter((i) => {
            // Children can be of type
            // ReactElement | string | number | ReactFragment | ReactPortal | boolean | null | undefined;
            const isDisplayed =
              i && // Don't show if the child is `null` or `undefined`.
              ((typeof i === 'object' && // Don't look for props if the child is `string` | `number` | `boolean`.
                'props' in i &&
                (i.props.show === undefined || i.props.show)) || // If `show` is undefined, assume the element should be shown.
                typeof i !== 'object');
            return isDisplayed;
          }),
          (child, index) => (
            <FlexGridItem key={index}>{child}</FlexGridItem>
          )
        )}
      </FlexGrid>
    </DetailsContainer>
  </Card>
);

export const CardText = ({ children }: PropsWithChildren<{}>) => (
  <div style={{ marginBottom: '12px' }}>
    <Label2>{children}</Label2>
  </div>
);
